"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioPreload = void 0;
var AudioPreload;
(function (AudioPreload) {
    // No preloading, samples is loaded when key is pressed.
    AudioPreload["ON_DEMAND"] = "on-demand";
    // Loop through each key, and preload one sample for each key.
    AudioPreload["PROGRESSIVE"] = "progressive";
    // Loop through order of the file, and preload each sample.
    AudioPreload["SEQUENTIAL"] = "sequential";
})(AudioPreload || (AudioPreload = {}));
exports.AudioPreload = AudioPreload;
